<template>
  <li class="card__item">
    <div class="l-gutter">
      <a :href="item.url" target="_blank">
        <img class="img-resp" :src="item.src">
      </a>
      <p class="card__desc text-right">{{ item.cate }}</p>
    </div>
  </li>
</template>

<script>
export default {
  name: 'Card',
  props: ['item'],
}
</script>

<style>
.card .l-gutter {
  padding: 1em;
  background-color: #fff;
}

.card__ls {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.card__item {
  padding: 1em;
}

.card__desc {
  margin-top: 10px;
  margin-bottom: 0;
  color: #999;
}

</style>



// WEBPACK FOOTER //
// src/components/Card.vue